/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if(boostSDAppConfig?.filterSettings) {
  boostSDAppConfig.filterSettings.filterAvoidStickyHeader = ['header.header']; //Please modify this array
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductImage', {
        name: 'Move anchor tag',
        apply: () => ({
            afterRender(element) {
                const link = element.getRootElm()?.closest('a');
                const linkWrapper = link?.parentElement;
                const linkClone = link?.cloneNode();
                const imgWrapper = link?.querySelector('.boost-sd__product-image');

                if (!linkWrapper || !link || !imgWrapper || !linkClone) return;
                //move anchor tag inside img wrapper
                linkClone.innerHTML = '';
                imgWrapper.appendChild(linkClone)

                //remove old anchor tag
                linkWrapper.innerHTML = '';
                linkWrapper.appendChild(link.childNodes[0]);

            },
        }),
    });

    componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Update percent sale',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                    if (productData.variants.length > 1) {
                      let variant = productData.variants.find(e => e.compare_at_price);
                      if (typeof variant != 'undefined') {
                        let price = parseFloat(variant.price);
                        let compareAtPrice = parseFloat(variant.compare_at_price);
                        let percentSale = Math.round(((compareAtPrice - price)/compareAtPrice)*100);
                        productItem.querySelector('.boost-sd__product-label--sale i').innerHTML = percentSale + '% Off';
                        
                      }
                    }
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
}]);